import React, {useId} from "react";
import {Controller, UseControllerProps, useFormContext} from "react-hook-form";

import {Switcher} from "@pg-design/switcher-module";
import {ISwitcherProps} from "@pg-design/switcher-module/src/components/Switcher";

type IProps = Omit<ISwitcherProps, "name" | "labelContent" | "aria-labelledby" | "onChange" | "id" | "checked"> & {
    name: string;
    labelContent: React.JSX.Element | string;
    rules?: UseControllerProps["rules"];
};

export const SwitcherControlled = (props: IProps) => {
    const {name, rules, ...restProps} = props;
    const {control} = useFormContext();

    return (
        <Controller
            name={name}
            rules={rules}
            control={control}
            render={({field}) => {
                const {ref: _ref, ...fieldProps} = field;

                return (
                    <Switcher
                        {...fieldProps}
                        {...restProps}
                        value={field.value}
                        onChange={(value) => field.onChange(value)}
                        checked={field.value}
                        id={useId()}
                    />
                );
            }}
        />
    );
};
